import { IS_MOBILE } from '../config';

// ── THE LOOK, IN TIERS ───────────────────────────────────────────────────────
//
// One place decides how much of the new render pipeline a device gets. The
// premium look is the target (Khari, 2026-07-23: "don't dumb it down"), so the
// tiers scale DENSITY and RESOLUTION, never the art direction: a phone sees the
// same sky, the same sun, the same grade and the same lit streets as a desktop,
// with fewer samples behind them.
//
//   ultra  desktop, by request — full-res AO, 4096 shadows, widest shadow reach
//   high   desktop default — half-res AO, 2048 follow-shadows, every effect
//   low    phones — no AO, no shadows (the Canvas already withholds them),
//          bloom at half resolution, cheaper clouds; the grade and the
//          atmosphere are one fullscreen pass and stay
//   off    the pre-2026-10 look exactly — no post, the Gemini sky panoramas,
//          the original light rig. For A/B, and the escape hatch if a device
//          misbehaves.
//
// ?fx=off|low|high|ultra pins a tier. ?look=classic is the same as ?fx=off.
const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
const asked = (params.get('fx') || '').toLowerCase();
const classic = params.get('look') === 'classic' || asked === '0' || asked === 'off';

function pick() {
  if (classic) return 'off';
  if (['low', 'high', 'ultra'].includes(asked)) return asked;
  return IS_MOBILE ? 'low' : 'high';
}

export const TIER = pick();
export const NEXT_LOOK = TIER !== 'off';

const T = {
  off:   { post: false, ao: 0, aoHalf: true, bloomRes: 1, shadowSize: 2048, shadowReach: 0,  cloudOctaves: 0, detailNormals: false, smaa: false },
  low:   { post: true,  ao: 0, aoHalf: true, bloomRes: 0.5, shadowSize: 0,  shadowReach: 0,  cloudOctaves: 3, detailNormals: false, smaa: false },
  high:  { post: true,  ao: 1, aoHalf: true, bloomRes: 1, shadowSize: 2048, shadowReach: 55, cloudOctaves: 5, detailNormals: true,  smaa: true },
  ultra: { post: true,  ao: 2, aoHalf: false, bloomRes: 1, shadowSize: 4096, shadowReach: 75, cloudOctaves: 6, detailNormals: true,  smaa: true },
};

export const QUALITY = { tier: TIER, ...T[TIER] };

// Individual kill switches, for isolating one effect without losing the rest.
// ?ao=0 ?bloom=0 ?grade=0 ?haze=0 ?pools=0 ?wet=0 ?clouds=0 ?nm=0 (derived normals)
const off = (k) => params.get(k) === '0';
QUALITY.aoOn = QUALITY.ao > 0 && !off('ao');
QUALITY.bloomOn = QUALITY.post && !off('bloom');
QUALITY.gradeOn = QUALITY.post && !off('grade');
QUALITY.hazeOn = QUALITY.post && !off('haze');
QUALITY.poolsOn = NEXT_LOOK && !off('pools');
QUALITY.wetOn = NEXT_LOOK && !off('wet');
QUALITY.cloudsOn = NEXT_LOOK && !off('clouds');
QUALITY.normalsOn = QUALITY.detailNormals && !off('nm');

if (typeof window !== 'undefined') {
  console.log(`[look] tier ${TIER}${NEXT_LOOK ? '' : ' (classic look)'} — ?fx=off|low|high|ultra to compare`);
}
